import { servableEngineLabel, tierDuration } from "./engines.js";

/**
 * The one sentence the #5636 confirm asks before a scenario runs on a deep-lane engine it
 * inherited from its main forecast while the picker says otherwise. Labels the depth the
 * request would ACTUALLY run on (servableEngineLabel — the same re-pointing isDeepEngine
 * applies), so a retired lane id never leaks into the copy. Pure and exported on its own so
 * the copy is testable as a string and the modal (`components/BranchEngineConfirmModal.jsx`)
 * cannot drift.
 */
export function branchEngineConfirmText(inheritedEngine, pickerEngine) {
  const inherited = servableEngineLabel(inheritedEngine);
  const picker = pickerEngine ? servableEngineLabel(pickerEngine) : null;
  const duration = tierDuration("deep");
  const lead =
    picker && picker !== inherited
      ? `Your depth is set to ${picker}, but this scenario will use ${inherited}, like the main forecast.`
      : `This scenario will use ${inherited}, like the main forecast.`;
  return duration ? `${lead} ${inherited} can take ${duration}.` : lead;
}
